export const normalizePhone = (phone) => String(phone || "").replace(/\D/g, "").slice(-10);
export const cartKey = (phone) => `vs_saved_cart_${normalizePhone(phone)}`;
export const emptyCart = () => ({
  cartId: crypto.randomUUID(), revision: 0, items: [], version: 2,
  baseRevision: 0, baseItems: [], dirty: false, changeId: null, editedAt: 0,
});

export function readCart(phone) {
  if (!phone) return null;
  try {
    const normalized = normalizePhone(phone);
    const keys = [cartKey(phone), `vs_saved_cart_${phone}`, `vs_saved_cart_+91${normalized}`, `vs_saved_cart_91${normalized}`];
    for (const key of [...new Set(keys)]) {
      const data = JSON.parse(localStorage.getItem(key));
      if (data?.cartId && Number.isSafeInteger(data.revision) && Array.isArray(data.items)) {
        return { ...data, items: data.items.filter((item) => item.product?.id && Number.isInteger(item.qty) && item.qty > 0) };
      }
    }
  } catch { /* Server restoration still works when browser storage is unavailable. */ }
  return null;
}

export function persistCart(phone, cart) {
  if (!phone) return;
  try {
    const value = JSON.stringify(cart);
    if (localStorage.getItem(cartKey(phone)) !== value) localStorage.setItem(cartKey(phone), value);
  } catch { /* Keep in-memory and server copies. */ }
}

export const cartPayload = (cart) => ({
  cart_id: cart.cartId, revision: cart.revision,
  base_revision: cart.baseRevision || 0, mutation_id: cart.changeId,
  items: cart.items.map(({ product, qty, size_quantities = {}, details = "" }) => ({ product_id: product.id, qty, size_quantities, details })),
});